import React from "react";
import { Link } from "react-router-dom";
import mousepointer from "../../assets/images/mouse_hand.png";

const NavButtons = () => {
  return (
    <div className="  block md:grid grid-cols-4  md:gap-2 m-4">
      {[
        { name: "PipeLine & Financials", path: "/piplineAndService" },
        { name: "Service & Spares", path: "/Services" },
        { name: "Complaints", path: "/complaints" },
        { name: "Fleet Edge", path: "/fleetEdge" },
        // { name: "Fleet Insights", path: "/fleet-insigths" },

      ].map((btn) => (
        <>
          <style>
            {`
      @keyframes blink {
        0%, 100% { opacity: 1; }
        50% { opacity: 0; }
      }
      .blink {
        animation: blink 3s infinite;
      }
    `}
          </style>

          <Link
            key={btn.path}
            to={btn.path}
            className="
      bg-[#2374BF] text-white px-2 py-1  rounded-md flex justify-center mt-1 md:mt-0 items-center gap-4
      border border-[#5eb3ff]
      shadow-[0_0_3px_1px_rgba(35,116,191,0.4)]
      transition-shadow duration-300
      hover:shadow-[0_0_4px_1px_rgba(94,179,255,0.5)]
      hover:border-[#7ec8ff]
    "
          >
            <p>{btn.name}</p>
            <img src={mousepointer} alt="" className="blink" />
          </Link>
        </>
      ))}
    </div>
  );
};

export default NavButtons;
